// removed by extract-text-webpack-plugin
module.exports = {"root":"kits--root--3Kgumefk home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","grid-container":"kits--grid-container--2yagSw0L home--grid-container--3c3JLjRI","gridContainer":"kits--grid-container--2yagSw0L home--grid-container--3c3JLjRI","form-container":"kits--form-container--2dyE0md0 home--message--9FSspPIv","formContainer":"kits--form-container--2dyE0md0 home--message--9FSspPIv","title":"kits--title--3Msgzzid crops--title--3nbOw3vq","reminder":"kits--reminder--3h57rt0l"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/cl-multiplier/kits/styles.css
// module id = ./views/refunds/cl-multiplier/kits/styles.css
// module chunks = 0